import styled from 'styled-components';

export const LabelContainer = styled.div`
    label {
        display: flex;
        flex-direction: column;
        row-gap: 5px;
        margin-bottom: 1em;

        span {
            font-size: 1em;
        }

        input {
            padding-left: 1em;
            height: 45px;
            border: 1px solid #D9D9D9;
        }

        span.require {
            color: tomato;
            font-size: 14px;
            padding-top: 2px;
        }

        p {
            margin: 0;
            font-size: 16px;
        }
    }
    
`

export const Container = styled.div`
    flex: 1 1 auto;  
    display: flex;
    flex-direction: column;

    .separator {
        display: block;
        border-bottom: 2px solid var(--secundary-color);
        margin-bottom: 2em;
    }

    .content {
        margin-bottom: 2.5em;

        button {
            margin-top: 1.5em;
            max-width: 100%;
            width: 100%;
        }
    }    
`

export const Success = styled.section`
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h1 {
        text-align: center;
        font-size: 1.5em;
        max-width: 288px;
    }
    
    button {
        width: 100%;
        max-width: 100%;
    }
`